import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Routes from './router';
import theme from './themes/default.theme';
import GlobalStyles from '@isomorphic/shared/hotel/assets/style/Global.style';
import AuthProvider from './context/AuthProvider';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

const App = () => {

  ReactGA.initialize('UA-158313238-1');
  ReactPixel.init('378917115784716');
  
  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <BrowserRouter>
          <AuthProvider>
            <Routes />
          </AuthProvider>
        </BrowserRouter>
      </>
    </ThemeProvider>
  );
};
ReactDOM.render(<App />, document.getElementById('root'));
